const NATURE_EMPLOYMENT = 'Nature de l’emploi';
const CLASSIFICATION = 'Classification';
const CONTRACT = 'Contrat';

export const EMPLOYEE_TABLE = {
  HEADER_TITLES: {
    NAME: 'Nom Prénom',
    ESTABLISHMENTS: 'Etablissement',
    NATURE_EMPLOYMENT,
    CLASSIFICATION,
    CONTRACT,
    ENTRY_DATE: 'Date d’entrée',
    RELEASE_DATE: 'Date de sortie',
    SCHEDULE: 'Horaire',
  },
  ACTIONS: {
    ABSENCES: 'Absences',
    LEAVE: 'Congés',
  },
};

export const EMPLOYEE_HEADER = {
  FILTER_PLACEHOLDERS: {
    ESTABLISHMENT: 'Etablissement',
    NATURE_EMPLOYMENT,
    CLASSIFICATION,
    CONTRACT,
    SEARCH_BY_NAME: 'Rechercher par nom',
  },
  FILTER_TITLE: 'Les filtres',
  BUTTONS_LABELS: {
    DOWNLOAD: 'Télécharger',
    DOWNLOAD_LONG: 'Télécharger les salariés',
    DOWNLOAD_PAYSLIP: 'Télécharger les bulletins de salaire sur cette période',
    DOWNLOAD_PAYSLIP_SHORT: 'Télécharger tous les bulletins de salaire',
    NEW_EMPLOYEE: 'Ajouter nouveau salarié',
    SAVE: 'Sauvegarder',
    CANCEL: 'Annuler',

    DOWNLOAD_PAYMENT_STATUS: 'Etat des paiements',
    DOWNLOAD_PAY_JOURNAL: 'Journal de paie',
    DOWNLOAD_PAY_SUMMARY: 'Récapitulatif de paie',
    DOWNLOAD_REST_BALANCE: 'Solde de repos',
    DOWNLOAD_CHARGES_TABLE: 'Tableau des charges',
    DOWNLOAD_SALARY_COSTS: 'Coûts salariaux',
    DOWNLOAD_CONTRIBUTION_DETAILS: 'Détail des cotisations',
    SILAE_SYNCING: 'Forcer la mise à jour des informations',
    SILAE_SYNCING_REWARDS: 'Forcer la mise à jour des informations des EVP',
  },
  WAITING_MODAL: {
    DOWNLOAD: 'Сhargement',
    TEXT: 'En fonction du nombre de salariés, le téléchargement de leurs bulletins de salaire peut être long, merci de bien vouloir patienter et de ne pas fermer cette page',
    OTHER_DOCUMENTS_TEXT:
      'En fonction du nombre de salariés, le téléchargement de ce document peut être long, merci de bien vouloir patienter et de ne pas fermer cette page',
  },
  SINGLE_WAITING_MODAL: {
    DOWNLOAD: 'Сhargement',
    TEXT: 'Génération du document en cours, merci de patienter',
  },
  IS_SILAE_SYNCING: 'Mise à jour des données en cours, merci de patienter',
  CHOSE_MODAL: {
    TITLE: 'Choisissez le format de téléchargement',

    PDF: {
      TITLE: 'PDF unique',
      DESCRIPTION: 'Toutes les fiches de paie dans un seul fichier PDF',
    },
    ZIP: {
      TITLE: 'ZIP avec PDFs',
      DESCRIPTION: 'Un fichier PDF par employé, compressé dans un ZIP',
    },
  },
};

export const NO_DATA_FOUND = {
  TEXT_FIRST_LINE: 'Aucun résultat',
  TEXT_SECOND_LINE: 'Veuillez modifier votre demande',
  BUTTON_RESET_FILTERS: 'Effacer les filtres',
};

export const TIME_TABLE_MODAL = {
  TITLE: 'Horaire applicable au salarié',
  TOTAL: 'Total',
  SEPARATOR: 'et',
};

export const SILAE_API_ERRORS = {
  NO_DATA_EMPLOYEES:
    'Aucun bulletin de salaire n’est disponible sur la période sélectionnée',
  NO_DATA_EMPLOYEE:
    'Aucun bulletin de salaire n’est disponible pour ce salarié sur la période sélectionnée',
};

export const SILAE_WARNINGS = {
  EMPLOYEE_TIMEOUT: 'Mise à jour des données en cours, merci de patienter',
};
